import * as actionTypes from "./constant";

const initialState = {
    pinUpdateFailedData:[]
}

export default function BulkPinUpdateReducer(state = initialState, action){
    switch (action.type) {
        case actionTypes.BULK_PIN_UPDATE_SUCCESS_ACTION:
          
          return {
            ...state,
            pinUpdateFailedData: action.payload.pincodeStatus,
          };
        case actionTypes.CLEAR_BULK_UPDATED_PIN_DATA_INIT_ACTION:
          return {
            ...state,
            pinUpdateFailedData: action.payload
          }
        
   default :
   return {
    ...state,
  };
}
}